/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { createSelector } from 'reselect';
import { expandSkillMentionsForPrompt } from '@/lib/pieveComposerSkillMentions.js';
import { EMPTY_OBJECT } from '@/redux/selectors/pieveSelectors/constants.js';

export const composerDraft = (state) => state?.pieve?.composerDraft || '';
export const composerDraftEntriesByContextKey = (state) => state?.pieve?.composerDraftsByContextKey || EMPTY_OBJECT;

export const composerDraftEntryByContextKey = (state, contextKey) => {
  const normalizedContextKey = String(contextKey || '').trim();

  if (!normalizedContextKey) {
    return null;
  }

  return composerDraftEntriesByContextKey(state)?.[normalizedContextKey] || null;
};

export const composerDraftByContextKey = (state, contextKey) => {
  return String(composerDraftEntryByContextKey(state, contextKey)?.value || '');
};

export const composerExpandedPromptByContextKey = createSelector([composerDraftByContextKey], (draftValue) => {
  return String(expandSkillMentionsForPrompt(String(draftValue || '')) || '').trim();
});

export const composerHasExpandedPromptByContextKey = createSelector([composerExpandedPromptByContextKey], (expandedPromptDraft) => {
  return Boolean(expandedPromptDraft);
});

export const composerEstimatedPromptTokensByContextKey = createSelector([composerExpandedPromptByContextKey], (expandedPromptDraft) => {
  return Math.max(0, Math.ceil(expandedPromptDraft.length / 4));
});
